import { Component, OnInit, Input, inject } from "@angular/core";
import { HistoryDataService } from "@services/http/history/HistoryDataService";
import { HistoryModel, HistoryType } from "@models/history/HistoryModel";
import { LocalizationService } from "..";
import { isGuid } from "@methods/uniqueMethods";
import { HistoryMethods } from "@methods/HistoryMethods";
import { provideTranslocoScope, TranslocoPipe } from "@jsverse/transloco";
import { MatExpansionModule } from "@angular/material/expansion";
import { DateTimeFormatPipe } from "@app/shared/pipes/date-time-format.pipe";
import { HistoryDetailComponent } from "./history-detail/history-detail.component";

@Component({
    selector: "app-history-overview",
    templateUrl: "./history-overview.component.html",
    styleUrls: ["./history-overview.component.scss"],
    providers: [
        provideTranslocoScope({ scope: "shared/history-overview", alias: "historyOverview" }),
    ],
    imports: [MatExpansionModule, HistoryDetailComponent, DateTimeFormatPipe, TranslocoPipe]
})
export class HistoryOverviewComponent implements OnInit {
    private localizationService = inject(LocalizationService);

    @Input() historyDataService: HistoryDataService;
    @Input() Id: number | string;
    @Input() ExtraParam: any;
    @Input() useOldHistory = false;
    @Input() useLazyLoading = true;
    @Input() label: string;

    isLoading: boolean;
    isValidObject = false;

    historyModels: HistoryModel[];
    displayedColumn: string[] = ["Column", "OldValue", "NewValue"];
    HistoryType = HistoryType;

    ngOnInit() {
        if (!this.useLazyLoading) {
            this.loadHistory();
        }
    }

    loadHistory() {
        this.isValidObject = this.Id && (+this.Id > 0 || isGuid(this.Id.toString()));
        if (this.isValidObject) {
            this.isLoading = true;
            this.historyDataService.getHistory(this.Id, this.ExtraParam).subscribe(
                (history) => {
                    this.historyModels = history;
                },
                () => {
                    this.isLoading = false;
                },
                () => {
                    this.isLoading = false;
                }
            );
        } else {
            this.isLoading = false;
        }
    }

    loadChanges(historyModel: HistoryModel) {
        if (historyModel.CombinedChanges) {
            return;
        }

        // Workaround for long long rounding
        const historyId = !this.useOldHistory ? historyModel.ID : historyModel.CerrixMutationDate;

        this.historyDataService
            .getHistoryChanges(this.Id, historyId, this.ExtraParam)
            .subscribe((changes) => {
                const combinedChanges = HistoryMethods.processChanges(
                    changes,
                    this.localizationService
                );
                historyModel.CombinedChanges = combinedChanges;
            });
    }
}
